module.exports = __webpack_public_path__ + "media/images/chevron_down_icon-83fc0e4e.svg";